export const FORM_ELEMENTS_CSS_CLASSES = 'rounded-md border border-gray-300 hover:border-gray-400 focus:border-prussian-blue-500 focus:ring-0'
export const FORM_ELEMENTS_CSS_CLASSES_ERR = 'rounded-md border-2 border-red-300 hover:border-red-400 focus:border-red-200 focus:ring-0'
